// ============================================
// Path: /frontend/src/pages/admin/ListingsAdminPage.jsx
// Purpose: Admin page to manage all listings (approve, reject, edit, delete)
// ============================================

// ========================================
// IMPORTS
// ========================================
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '../../components/ui/card';
import { ListingsTable } from '../../components/admin/ListingsTable';

// ========================================
// MAIN COMPONENT
// ========================================
export default function ListingsAdminPage() {
  console.log('🎨 [ListingsAdminPage] Component mounted');

  // ========================================
  // RENDER
  // ========================================
  return (
    <Card>
      <CardHeader>
        <CardTitle>Manage Listings</CardTitle>
        <CardDescription>
          Approve, reject, edit, or delete vehicle and property listings.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ListingsTable />
      </CardContent>
    </Card>
  );
}